import { Flex } from 'antd';

import IconProcessingLoading from '@/assets/icons/processing-loading.svg?react';

export function ProcessingDataLoading() {
  return (
    <Flex align="center" justify="center" className="processing-data-loading">
      <IconProcessingLoading />
    </Flex>
  );
}
